import axios from "axios";
import { TokenService } from "./auth/storage.services";

const ApiService = {
  init(baseURL) {
    console.log('api', baseURL)
    axios.defaults.baseURL = baseURL;
  },


  setHeader() {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    const site = parts.length === 4 ? parts[0] : 'maisenvios';

    axios.defaults.headers.common.Authorization = `Bearer ${TokenService.getToken()}`;
    axios.defaults.headers.common["Content-Type"] = "application/json; charset=UTF-8";
    axios.defaults.headers.common["X-Mais-Host"] = site;
  },

  removeHeader() {
    delete axios.defaults.headers.common.Authorization;
    delete axios.defaults.headers.common["Content-Type"];
  },

  get(resource) {
    return new Promise((resolve, reject) => {
      axios
        .get(resource)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          if (error && error.response && error.response.data) {
            reject(error.response.data.message, error.response.status);
          } else {
            reject(error && error.message ? error.message : error);
          }
        });
    });
  },

  filter(resource, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(resource, params)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error.response.data.message, error.response.status);
        });
    });
  },

  post(resource, data, headers) {
    return new Promise((resolve, reject) => {
      axios
        .post(resource, data, { headers: headers })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          console.log('error', error)
          if (error && error.response && error.response.data) {
            if (Array.isArray(error.response.data)) {
              return reject(error.response.data.join("\n"));
            } else if (
              error.response.data.message &&
              Array.isArray(error.response.data.message)
            ) {
              return reject(error.response.data.message.join("\n"));
            } else {
              console.log('reject', error.response.data.message)
              return reject(error.response.data.message);
            }
          } else {
            reject(error);
          }
        });
    });
  },

  postUploadData(resource, formData) {
    return new Promise((resolve, reject) => {
      axios
        .post(resource, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${TokenService.getToken()}`,
          },
        })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error.response.data.message, error.response.status);
        });
    });
  },

  download(resource, data, headers) {
    return new Promise((resolve, reject) => {
      axios
        .post(resource, data, { responseType: "blob", headers: headers })
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          if (error && error.response && error.response.data) {
            reject(error.response.data.message);
          } else {
            reject(error);
          }
        });
    });
  },

  put(resource, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(resource, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          if (error && error.response && error.response.data) {
            if (
              error.response.data.error &&
              Array.isArray(error.response.data.error)
            ) {
              reject(error.response.data.error.join("\n"));
            } else {
              reject(error.response.data.message);
            }
          } else {
            reject(error);
          }
        });
    });
  },

  patch(resource, data) {
    return new Promise((resolve, reject) => {
      axios
        .patch(resource, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          if (error && error.response && error.response.data) {
            if (
              error.response.data.error &&
              Array.isArray(error.response.data.error)
            ) {
              reject(error.response.data.error.join("\n"));
            } else {
              reject(error.response.data.message);
            }
          } else {
            reject(error);
          }
        });
    });
  },
  delete(resource) {
    return new Promise((resolve, reject) => {
      axios
        .delete(resource)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error.response.data.message);
        });
    });
  },

  customRequest(data) {
    return axios(data);
  },
};

export default ApiService;
